import React from 'react'

import UptimalLogoImg from '../assets/uptimal-builder-logo.png'
import styles from '../styles/uptimal-logo.module.scss'

const UptimalLogo = () => {
  return (
    <img
      className={styles.uptimalLogo}
      src={UptimalLogoImg}
      alt="Uptimal Builder, powered by Uplifter"
    />
  )
}

export default UptimalLogo
